(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("dashboardLearner", {
        templateUrl: "app/dashboard/dashboardLearner.component.html",
        controller: ["dashboardResource", "accountDashboardResource", "messageService", "colorService", "frameworkService", "$translate", "$state", "$rootScope", DashboardLearnerCtrl],
        controllerAs: "vm"
    });
    function DashboardLearnerCtrl(dashboardResource, accountDashboardResource, messageService, colorService, frameworkService, $translate, $state, $rootScope) {
        var vm = this;
        vm.isPhone = jQuery.browser.mobile;
        vm.isReadOnly = $state.params.isReadOnly;
        vm.loadMyLearningPlan = loadMyLearningPlan;
        vm.loadMyTier = loadMyTier;
        vm.loadMyPoints = loadMyPoints;
        vm.loadQuickLinks = loadQuickLinks;
        vm.loadMyLeaderboard = loadMyLeaderboard;
        vm.loadMyBadges = loadMyBadges;
        vm.loadMyCertificates = loadMyCertificates;
        vm.$onInit = function () {
            load();
        };
        ////////////////////////////////////////////////////////////////////////
        function load() {
            if (vm.isReadOnly)
                loadAdmin();
            else
                loadLearner();
        }
        function loadAdmin() {
            if (frameworkService.data.tenantFeatures.gamificationPointSystem || frameworkService.data.tenantFeatures.gamificationTierSystem) {
                dashboardResource.getGamificationViewModel({ personSeq: $state.params.personSeq }, function (data) {
                    vm.gamificationSummary = data.gamificationSummary;
                    vm.gamificationLoaded = true;
                }, function (error) {
                    messageService.error(error);
                });
            }
            dashboardResource.getLearningViewModel({ personSeq: $state.params.personSeq }, function (data) {
                vm.learningData = data;
                processLearningData();
            }, function (error) {
                messageService.error(error);
            });
            if (frameworkService.data.tenantFeatures.gamificationLeaderboardSystem && frameworkService.data.tenantFeatures.gamificationPointSystem) {
                dashboardResource.getLeaderboardViewModel({ personSeq: $state.params.personSeq }, function (data) {
                    vm.leaderboard = data;
                    vm.leaderboardLoaded = true;
                }, function (error) {
                    messageService.error(error);
                });
            }
            vm.certificateLoading = true;
            dashboardResource.getCertificatesViewModel({ personSeq: $state.params.personSeq }, function (data) {
                vm.certificate = data;
                vm.certificateLoading = false;
            }, function (error) {
                messageService.error(error);
            });
            if (frameworkService.data.tenantFeatures.ceCredits) {
                vm.ceCreditsEnabled = true;
                vm.ceCreditsLoading = true;
                dashboardResource.getCECreditsView({ personSeq: $state.params.personSeq }, function (data) {
                    vm.ceCredits = data;
                    vm.ceCreditsLoading = false;
                }, function (error) {
                    messageService.error(error);
                });
            }
            if (frameworkService.data.tenantFeatures.openBadges) {
                vm.badgeLoading = true;
                dashboardResource.getBadgesViewModel({ personSeq: $state.params.personSeq }, function (data) {
                    vm.badges = data;
                    vm.badgeLoading = false;
                }, function (error) {
                    messageService.error(error);
                });
            }
        }
        function loadLearner() {
            if (frameworkService.data.tenantFeatures.gamificationPointSystem || frameworkService.data.tenantFeatures.gamificationTierSystem) {
                accountDashboardResource.getGamificationViewModel(function (data) {
                    vm.gamificationSummary = data.gamificationSummary;
                    vm.gamificationLoaded = true;
                }, function (error) {
                    messageService.error(error);
                });
            }
            accountDashboardResource.getLearningViewModel(function (data) {
                vm.learningData = data;
                processLearningData();
            }, function (error) {
                messageService.error(error);
            });
            if (frameworkService.data.tenantFeatures.gamificationLeaderboardSystem && frameworkService.data.tenantFeatures.gamificationPointSystem) {
                accountDashboardResource.getLeaderboardViewModel(function (data) {
                    vm.leaderboard = data;
                    vm.leaderboardLoaded = true;
                }, function (error) {
                    messageService.error(error);
                });
            }
            vm.certificateLoading = true;
            accountDashboardResource.getCertificatesViewModel(function (data) {
                vm.certificate = data;
                vm.certificateLoading = false;
            }, function (error) {
                messageService.error(error);
            });
            if (frameworkService.data.tenantFeatures.ceCredits) {
                vm.ceCreditsEnabled = true;
                vm.ceCreditsLoading = true;
                accountDashboardResource.getCECreditsView(function (data) {
                    vm.ceCredits = data;
                    vm.ceCreditsLoading = false;
                }, function (error) {
                    messageService.error(error);
                });
            }
            if (frameworkService.data.tenantFeatures.openBadges) {
                vm.badgeLoading = true;
                accountDashboardResource.getBadgesViewModel(function (data) {
                    vm.badges = data;
                    vm.badgeLoading = false;
                }, function (error) {
                    messageService.error(error);
                });
            }
        }
        function processLearningData() {
            vm.chartOptions = { thickness: 200 };
            vm.itemsChart = [
                { label: $translate.instant("common.assignmentStatus.Completed"), value: vm.learningData.itemCompletionStats.completed, color: colorService.getSuccessColor(), legend: "gamification.myTier.assignment.chart.legend.completed", cssClass: "text-completed" },
                { label: $translate.instant("common.assignmentStatus.Assigned"), value: vm.learningData.itemCompletionStats.assigned, color: colorService.getWarningColor(), legend: "gamification.myTier.assignment.chart.legend.assigned", cssClass: "text-assigned" },
                { label: $translate.instant("common.assignmentStatus.Expired"), value: vm.learningData.itemCompletionStats.expired, color: colorService.getDangerColor(), legend: "gamification.myTier.assignment.chart.legend.expired", cssClass: "text-expired" }
            ];
            vm.pathsChart = [
                { label: $translate.instant("common.assignmentStatus.Completed"), value: vm.learningData.pathCompletionStats.completed, color: colorService.getSuccessColor(), legend: "gamification.myTier.assignment.chart.legend.completed", cssClass: "text-completed" },
                { label: $translate.instant("common.assignmentStatus.Assigned"), value: vm.learningData.pathCompletionStats.assigned, color: colorService.getWarningColor(), legend: "gamification.myTier.assignment.chart.legend.assigned", cssClass: "text-assigned" },
                { label: $translate.instant("common.assignmentStatus.Expired"), value: vm.learningData.pathCompletionStats.expired, color: colorService.getDangerColor(), legend: "gamification.myTier.assignment.chart.legend.expired", cssClass: "text-expired" }
            ];
            //Show a gray chart if there is no assigned learning
            if (vm.learningData.itemCompletionStats.completed === 0 && vm.learningData.itemCompletionStats.assigned === 0 && vm.learningData.itemCompletionStats.expired === 0)
                vm.itemsChart.push({ label: "", value: 100, color: "#c8c5c5" });
            if (vm.learningData.pathCompletionStats.completed === 0 && vm.learningData.pathCompletionStats.assigned === 0 && vm.learningData.pathCompletionStats.expired === 0)
                vm.pathsChart.push({ label: "", value: 100, color: "#c8c5c5" });
            vm.learningLoaded = true;
        }
        function loadMyLearningPlan() {
            if (!vm.isReadOnly)
                $state.go("main.learningPlan");
        }
        function loadMyTier() {
            if (!vm.isReadOnly)
                $state.go("main.accountTier");
        }
        function loadMyPoints() {
            if (!vm.isReadOnly)
                $state.go("main.accountPoints");
        }
        function loadQuickLinks() {
            if (!vm.isReadOnly)
                $rootScope.$broadcast("toggleQuickLinks");
        }
        function loadMyLeaderboard() {
            if (!vm.isReadOnly)
                $state.go("main.accountPoints");
        }
        function loadMyBadges() {
            if (!vm.isReadOnly)
                $state.go("main.accountBadges.badges");
        }
        function loadMyCertificates() {
            if (!vm.isReadOnly)
                $state.go("main.accountCertificates");
        }
    }
}());
